import React, { useState, useEffect } from "react"
import gameActions from "../../../store/actions/gameActions"
import { useDispatch } from "react-redux"
import { motion } from 'framer-motion'

const Photo = ({ img, caption }) => {
    const dispatch = useDispatch()

    const photoVariants = {
        isClicked: {
            scale: [1, 1.2, 1.3, 1.2, 1],
            opacity: [0, 1, 0, 0.5, 1],
        },
        notClicked: { opacity: 1 },
    }

    const [isPhotoClicked, setPhotoClicked] = useState(false)

    useEffect(() => {
        setPhotoClicked(false)
    }, [img, caption])

    const onClickPhoto = () => {
        setTimeout(() => {
            setPhotoClicked(true)
            dispatch(gameActions.unlockAdvancedNarrative('foto'))
            dispatch(gameActions.takePhoto(img, caption))
        }, 200);
    }

    return (
        <div className='flex flex-col justify-center'>
            <h4 className='pb-0'>Fotografia</h4>
            <p className='pb-4'>Carregue na foto para tirar uma fotografia e avançar!</p>
            <motion.div
                animate={isPhotoClicked ? "isClicked" : "notClicked"}
                variants={photoVariants}
                className='flex justify-center relative'>
                <img
                    id='photo'
                    alt={caption}
                    title={caption}
                    style={{
                        maxHeight: 300,
                        filter: isPhotoClicked ? 'grayscale(100%)' : 'grayscale(0)',
                        WebkitFilter: isPhotoClicked ? 'grayscale(100%)' : 'grayscale(0)',
                        msFilter: isPhotoClicked ? 'grayscale(100%)' : 'grayscale(0)'
                    }}
                    src={require(`../../../assets/img/narrative/${img}`)}
                    className='photo object-contain'
                    onClick={() => !isPhotoClicked ? onClickPhoto() : null}
                />
                <div className='photo-icon'>
                    <img
                        title='Clique para tirar fotografia'
                        alt='Câmera fotográfica'
                        className='object-contain'
                        src={require('../../../assets/img/others/camera.png')}
                        onClick={() => !isPhotoClicked ? onClickPhoto() : null}
                    />
                </div>
            </motion.div>
        </div>
    )
}

export default Photo